import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProviders } from '@carbon/shared'

import { Route, Router } from 'react-router'
import { createBrowserHistory } from 'history'
import Docs from './Docs'
import NewDocs from './NewDocs'


const App = () => {
  const customHistory = createBrowserHistory()
  return (
    <React.StrictMode>
      <ThemeProviders>
        <Router history={customHistory}>
          <Route path={'/docs'}>
            <Docs />
          </Route>
          <Route path={'/v2/docs'}>
            <NewDocs />
          </Route>
        </Router>
      </ThemeProviders>
    </React.StrictMode>
  )
}

ReactDOM.render(
  App(),
  document.getElementById('root'),
)
